<template>
	<div class="widget-skeleton-field-wrapper widget-field-container">
		<v-skeleton-loader class="skeleton-field" :type="skeletonType" v-bind="loaderAttributes"></v-skeleton-loader>
	</div>
</template>

<script>
import widgetFieldTypes, { DEFAULT_SKELETON } from '@/components/BlockEditorWidget/widgetFieldTypes.js';

export default {
	name: 'WidgetSkeletonFieldWrapper',
	props: {
		field: { type: Object },
	},
	methods: {},
	data() {
		return {
			localField: this.field,
			loaderAttributes: {
				tile: true,
			},
		};
	},
	computed: {
		skeletonType() {
			return widgetFieldTypes[this.field.field_type]?.skeletonType || DEFAULT_SKELETON;
		},
	},
};
</script>

<style lang="scss">
.widget-skeleton-field-wrapper {
	position: relative;

	.skeleton-field {
		min-height: 40px;
		padding: 20px;
		cursor: default;
		.v-skeleton-loader__text {
			margin-top: 8px;
			height: 40px !important;
		}
	}
	.widget-field-container {
		position: relative;
		padding: 0px 15px;
		transition: all 0.35s;
		z-index: 1;

		.ff {
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			right: 0;
			z-index: 9999;
		}
		.v-text-field input::placeholder {
			color: #acb0b9 !important;
			opacity: 1;
		}
	}

	@media (max-width: 575px) {
		.widget-field-container {
			padding: 0px 15px;
		}
	}

	// Small devices (landscape phones, 576px and up)
	@media (min-width: 576px) {
		.widget-field-container {
			padding: 0px 15px;
		}
	}
}
</style>
